export const computeTopSim = async (resp) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v2/top-sim`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ swipeResponse: resp }),
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data['matches'];
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
